export const getFieldGroupsPending = () => {
    return {
        type: 'GET_FIELD_GROUPS_PENDING'
    }
};

export const getFieldGroupsSuccess = fieldGroups => {
    return {
        type: 'GET_FIELD_GROUPS_SUCCESS',
        fieldGroups
    }
};

export const getFieldGroupsError = error => {
    return {
        type: 'GET_FIELD_GROUPS_ERROR',
        error: error
    }
};

export const addFieldToGroupPending = () => {
    return {
        type: 'ADD_FIELD_TO_GROUP_PENDING'
    }
};

export const addFieldToGroupSuccess = () => {
    return {
        type: 'ADD_FIELD_TO_GROUP_SUCCESS'
    }
};

export const getFieldGroups = groupId => {

    const url = 'fields_groups';

    return dispatch => {
        dispatch(getFieldGroupsPending());

        fetch(`${process.env.REACT_APP_API_URL}/${url}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getFieldGroupsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                if (res.length) {
                    dispatch(selectFieldGroup(groupId ? res.find(x => x.id === groupId) : res[0], 0))
                }
                dispatch(getFieldGroupsSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const selectFieldGroup = (fieldGroup, page) => {
    return {
        type: 'SELECT_FIELD_GROUP',
        selected: { fieldGroup: fieldGroup, page }
    };
};

export const addFieldToGroup = (groupId, fieldId) => {
    return dispatch => {
        dispatch(addFieldToGroupPending());

        fetch(`${process.env.REACT_APP_API_URL}/add_field_to_group`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                groupId,
                fieldId
            })
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getFieldGroups(groupId));
                } else {
                    dispatch(getFieldGroupsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const createFieldGroup = name => {
    return dispatch => {
        dispatch(getFieldGroupsPending());

        fetch(`${process.env.REACT_APP_API_URL}/create_field_group/${name}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getFieldGroups());
                } else {
                    dispatch(getFieldGroupsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const deleteFieldGroup = fieldGroupId => {
    return dispatch => {
        dispatch(getFieldGroupsPending());

        fetch(`${process.env.REACT_APP_API_URL}/fields_groups/delete_fields_group/${fieldGroupId}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getFieldGroups());
                } else {
                    dispatch(getFieldGroupsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};


export const deleteFieldFromGroup = (groupId, fieldId) => {
    return dispatch => {
        dispatch(addFieldToGroupPending());

        fetch(`${process.env.REACT_APP_API_URL}/remove_field_from_group`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                groupId,
                fieldId
            })
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getFieldGroups(groupId));
                } else {
                    dispatch(getFieldGroupsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const addUserToGroup = (groupId, userId) => {
    return dispatch => {
        dispatch(addFieldToGroupPending());

        fetch(`${process.env.REACT_APP_API_URL}/add_user_to_group`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                groupId,
                userId
            })
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getFieldGroups(groupId));
                } else {
                    dispatch(getFieldGroupsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const deleteUserFromGroup = (groupId, userId) => {
    return dispatch => {
        dispatch(addFieldToGroupPending());

        fetch(`${process.env.REACT_APP_API_URL}/remove_user_from_group`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                groupId,
                userId
            })
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getFieldGroups(groupId));
                } else {
                    dispatch(getFieldGroupsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
